import { api } from '@/lib/api-client';
import { CreateViewRequest, TIER } from '@/types/view';
import { usePrivy } from '@privy-io/react-auth';
import { useMutation } from '@tanstack/react-query';

function getDeviceType(): 'desktop' | 'mobile' | 'tablet' {
  const width = window.innerWidth;
  if (width < 768) return 'mobile';
  if (width < 1024) return 'tablet';
  return 'desktop';
}

export function useTrackView() {
  const { user: privyUser } = usePrivy();

  return useMutation({
    mutationFn: async (
      data: Omit<CreateViewRequest, 'user_id' | 'device_type' | 'tier' | 'credits_used'>,
    ) => {
      const user_id = privyUser?.id || 'anonymous';
      const payload: CreateViewRequest = {
        ...data,
        user_id,
        device_type: getDeviceType(),
        tier: TIER.FREE, // Default to free tier
        credits_used: 0,
      };
      return api.createView(payload);
    },
    retry: 2,
    onError: console.error,
  });
}
